import React from 'react';
import { useSelector } from 'react-redux';
import Todo from './Todo';

const Todos = props => {
  const todos = useSelector(state => state.todoApp);
  const { onToggleStatus, onRemoveCard } = props;

  return (
    <div className="Todos">
      <ul className="List">
        {todos.map((todo, index) => (
          <li key={todo.id}>
            <Todo
              key={todo.id}
              index={index}
              onToggleStatus={onToggleStatus}
              onRemoveCard={onRemoveCard} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Todos;
